import { CheckCircle2, AlertCircle, Info, X } from 'lucide-react'
import { useToastStore, type Toast } from './store'
import { cn } from '@/lib/utils/cn'

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts)
  const dismiss = useToastStore((s) => s.dismiss)

  return (
    <div className="fixed top-4 right-4 z-[100] flex flex-col gap-2 pointer-events-none">
      {toasts.map((t) => (
        <ToastItem key={t.id} toast={t} onDismiss={() => dismiss(t.id)} />
      ))}
    </div>
  )
}

function ToastItem({ toast, onDismiss }: { toast: Toast; onDismiss: () => void }) {
  const styles = {
    default: { border: 'border-border', accent: 'border-l-fg', icon: <Info size={16} /> },
    success: { border: 'border-border', accent: 'border-l-success', icon: <CheckCircle2 size={16} className="text-success" /> },
    error:   { border: 'border-border', accent: 'border-l-error',   icon: <AlertCircle  size={16} className="text-error" /> },
    warning: { border: 'border-border', accent: 'border-l-warning', icon: <AlertCircle  size={16} className="text-warning" /> },
    info:    { border: 'border-border', accent: 'border-l-info',    icon: <Info         size={16} className="text-info" /> },
  }[toast.variant]

  return (
    <div
      role="status"
      className={cn(
        'pointer-events-auto flex items-start gap-2.5 px-3.5 py-3 min-w-[280px] max-w-[420px]',
        'bg-surface rounded-md shadow-md border-l-[3px] border',
        styles.border,
        styles.accent,
        'animate-in slide-in-from-top-2',
      )}
      style={{ animation: 'slideInRight 200ms cubic-bezier(0.34, 1.4, 0.64, 1)' }}
    >
      <span className="mt-0.5 shrink-0">{styles.icon}</span>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium">{toast.message}</div>
        {toast.description && (
          <div className="text-xs text-fg-muted mt-0.5">{toast.description}</div>
        )}
      </div>
      <button onClick={onDismiss} className="text-fg-subtle hover:text-fg shrink-0">
        <X size={14} />
      </button>
    </div>
  )
}
